import { createAction, props } from '@ngrx/store';

import { IResultEnfriadores } from '../../shared/models/Enfriadores.model';

/**
 * * Obtiene los datos de enfriadores para conexión url
 */
export const getEnfriadores = createAction(
    '[Enfriadores] Data Enfriadores Url',
);

export const successEnfriadores = createAction(
    '[Enfriadores] Data Enfriadores Url Success',
    props<IResultEnfriadores>()
);

export const errorEnfriadores = createAction(
    '[Enfriadores] Data Enfriadores Url Error',
    props<{ payload: Error }>()
);

export const clearEnfriadores = createAction(
    '[Enfriadores] Data Enfriadores Url Clear'
);
